import { memo } from "react";
import { Form, Input, Button, Checkbox, Typography, Alert } from "antd";
import {
  UserOutlined,
  LockOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
  ArrowRightOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { LOGIN_COPY } from "../login.constants";

const { Title, Text } = Typography;

function LoginFormComponent({
  form,
  loading,
  error,
  onSubmit,
  onErrorClose,
  onForgotPasswordClick,
}) {
  return (
    <div className="login-card">
      <Title level={4} className="login-card__heading">
        {LOGIN_COPY.welcome}
      </Title>
      <Text className="login-card__subheading">{LOGIN_COPY.subtitle}</Text>

      {error && (
        <Alert
          role="alert"
          type="error"
          message={error}
          showIcon
          className="login-card__alert"
          closable
          onClose={onErrorClose}
        />
      )}

      <Form form={form} layout="vertical" onFinish={onSubmit} requiredMark={false}>
        <Form.Item
          label={<Text className="login-form-label">UST UID</Text>}
          name="userId"
          className="login-form-item"
          rules={[
            { required: true, message: "UST UID is required" },
            { len: 6, message: "UST UID must be exactly 6 characters." },
          ]}
        >
          <Input
            prefix={<UserOutlined className="login-input__icon" />}
            placeholder="Enter your UST UID"
            size="middle"
            className="login-input"
            autoComplete="username"
          />
        </Form.Item>

        <Form.Item
          label={<Text className="login-form-label">Password</Text>}
          name="password"
          className="login-form-item"
          rules={[{ required: true, message: "Password is required" }]}
        >
          <Input.Password
            prefix={<LockOutlined className="login-input__icon" />}
            placeholder="Enter your Password"
            size="middle"
            className="login-input"
            autoComplete="current-password"
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>

        <div className="login-options">
          <Form.Item name="remember" valuePropName="checked" noStyle>
            <Checkbox className="login-checkbox">Remember me</Checkbox>
          </Form.Item>
          <Button
            type="link"
            htmlType="button"
            className="login-link-button"
            onClick={onForgotPasswordClick}
          >
            Forgot Password?
          </Button>
        </div>

        <Form.Item className="login-form-item" style={{ marginBottom: 18 }}>
          <Button
            type="primary"
            htmlType="submit"
            block
            size="middle"
            loading={loading}
            className="login-submit-button"
          >
            Sign In <ArrowRightOutlined className="login-submit-icon" />
          </Button>
        </Form.Item>
      </Form>

      <div className="login-register">
        <Text className="login-register__text">
          Don't have an account?{" "}
          <Link to="/watchtower/register">
            <Button type="link" className="login-link-button">
              Create Account
            </Button>
          </Link>
        </Text>
      </div>
    </div>
  );
}

export const LoginForm = memo(LoginFormComponent);
